import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styles from '../FormStyles.module.scss'

const AdditionalDetailsFormSection = (props) => {
  const {
    title,
    description,
    children,
    showBottomLine
  } = props

  return (
    <Fragment>
      <div className={styles.description}>
        {title}
      </div>
      <div className={styles.text}>
        {description}
      </div>
      {children}
      {showBottomLine && <div className={styles.lineSeparatorLight} />}
    </Fragment>
  )
}
AdditionalDetailsFormSection.defaultProps = {
  showBottomLine: true,
  description: ''
}

AdditionalDetailsFormSection.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  children: PropTypes.node.isRequired,
  showBottomLine: PropTypes.bool
}

export default AdditionalDetailsFormSection



// WEBPACK FOOTER //
// ./src/components/Onboarding/AdditionalDetails/AdditionalDetailsFormSection.jsx